/**
 * Asset utility functions
 */

import { toast } from "sonner";

/**
 * Download an asset using its download URL
 * Uses direct link approach since presigned URLs are already CORS-enabled
 */
export async function downloadAsset(
  downloadUrl: string,
  fileName: string,
): Promise<void> {
  try {
    // Create a temporary link element and trigger download
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = fileName;
    a.target = "_blank"; // Fallback: open in new tab if download fails
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    toast.success("Download started");
  } catch (error) {
    toast.error("Failed to download asset");
    throw error;
  }
}

/**
 * Open an asset in a new tab using its download URL
 */
export function openAssetInNewTab(downloadUrl: string): void {
  window.open(downloadUrl, "_blank");
}
